/** @jsxImportSource react */
import { Link } from '@react/system';
import { Select } from '@react/system';
import cx from 'classnames';
import { useRouter } from 'next/router';
import React, { useCallback } from 'react';

export interface TabNavigationProps {
  currentLink: string;
  linksList: Links[];
}

interface Links {
  title: string;
  to: string;
}

const capitalize = (str: string) =>
  str[0].toUpperCase() + str.slice(1).toLowerCase();

const TabNavigation = ({ linksList, currentLink }: TabNavigationProps) => {
  const router = useRouter();

  const mobileLinksList = linksList?.map(({ title, to }) => {
    return { label: capitalize(title), value: to };
  });

  const handleChange = useCallback(
    ({ label, value }: { label: string; value: string }) => {
      label.toLowerCase() === 'careers'
        ? window.open(value, '_blank')
        : router.push(value);
    },
    [router]
  );

  return (
    <>
      <div
        className='my-s mx-m md:hidden'
        data-tp-id='gen-Block-7ea2b095-6662-4046-9bea-315235567d07'
      >
        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
        {/*@ts-ignore*/}
        <Select
          size='large'
          options={mobileLinksList}
          defaultValue={mobileLinksList?.find(
            ({ value, label }) => value === currentLink && label
          )}
          onChange={(e: any) => handleChange(e)}
        />
      </div>
      <div
        className={cx(
          'mx-auto hidden h-12 w-[64.5rem]',
          'md:flex lg:items-center lg:justify-center',
          'flex items-center justify-center md:w-[31.5rem]'
        )}
        data-tp-id='gen-Block-a37ae72d-c25e-4dcf-a817-41cccad312e4'
      >
        {linksList?.map(({ title, to }, index) => {
          const isActiveLink = to === currentLink;
          return (
            <Link
              className={cx(
                'cursor-pointer uppercase hover:no-underline',
                linksList.length - 1 !== index && 'mr-l',
                'font-l-m',
                isActiveLink
                  ? '!text-viridian-base '
                  : '!text-slate-lighter-40',
                'pt-m',
                isActiveLink ? 'border-b-4 border-viridian-base pb-s' : 'pb-m'
              )}
              key={title}
              to={to}
              data-tp-id='gen-Link-b8f1a297-79a7-4666-91ef-15493e95486e'
            >
              {title.toUpperCase()}
            </Link>
          );
        })}
      </div>
    </>
  );
};

export default TabNavigation;
